import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirstService {
  private http = inject(HttpClient);
  
  fetchData() {
    return this.http.get(`${environment.apiUrl}/users`);
  }

  constructor() { }
}
